import React from 'react';
import * as Sentry from '@sentry/react';
import * as ReactDOMClient from 'react-dom/client';
import { Provider } from 'react-redux';

import store from 'store';
import { history } from 'views/_app/Routes/Routes';
import { CustomThemeProvider } from 'hooks/useCustomTheme';

import App from 'views/_app';

if (!!process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    release: `${process.env.npm_package_name}@${process.env.npm_package_version}`,
    // https://github.com/getsentry/sentry-javascript/issues/2514#issuecomment-603971338
    beforeSend(event, hint) {
      if (hint.originalException === 'Timeout') return null;
      return event;
    },
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    integrations: [
      Sentry.browserTracingIntegration({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [],
      }),
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),
      process.env.REACT_APP_ENV === 'prod' && Sentry.replayIntegration(),
    ].filter(Boolean),
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOMClient.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <Provider store={store}>
    <CustomThemeProvider>
      <App />
    </CustomThemeProvider>
  </Provider>,
  /* </React.StrictMode> */
);
